<!-- 🔹 Modern Signature Modal Structure -->
<div *ngIf="visible" class="fixed inset-0 z-[500] flex items-center justify-center backdrop-blur-md bg-black/40 p-4"
  (click)="onCancel()">
  <div
    class="relative bg-white dark:bg-gray-900 rounded-[28px] shadow-2xl w-full max-w-[380px] overflow-hidden p-6 border border-gray-100/10 dark:border-gray-800 flex flex-col"
    (click)="$event.stopPropagation()">

    <!-- Sophisticated background accents -->
    <div class="absolute -top-10 -right-10 w-32 h-32 bg-primary/80 rounded-full blur-3xl"></div>
    <div class="absolute -bottom-10 -left-10 w-24 h-24 bg-primary/80 rounded-full blur-2xl"></div>

    <div class="pt-4 flex flex-col items-center text-center">

      <!-- Iconic Signature Section -->
      <div class="relative mb-6">
        <!-- Pulse effect for premium feel -->
        <div
          class="absolute inset-0 blur-2xl opacity-20 scale-150 animate-pulse bg-current transition-colors duration-500"
          [ngClass]="{
               'text-primary': type === 'confirmation' || type === 'question' || type === 'logout',
               'text-red-500': type === 'delete' || type === 'alert'
             }"></div>

        <!-- Main Hub Icon (Premium Housing) -->
        <div
          class="relative w-20 h-20 rounded-[28px] flex items-center justify-center shadow-[inset_0_2px_10px_rgba(255,255,255,0.8),0_10px_30px_rgba(0,0,0,0.05)] border border-white/40 dark:border-gray-800"
          [ngClass]="{
               'bg-gradient-to-br from-primary-50 to-primary-100/50 dark:from-primary-500/20 dark:to-primary-600/5 text-primary-600': type === 'confirmation' || type === 'question' || type === 'logout',
               'bg-red-50 dark:bg-red-500/20 text-red-600': type === 'delete' || type === 'alert'
             }">
          @switch (type) {
          @case ('confirmation') { <span class="iconify text-5xl drop-shadow-sm"
            data-icon="solar:check-circle-bold-duotone"></span> }
          @case ('question') { <span class="iconify text-5xl drop-shadow-sm" data-icon="solar:help-bold-duotone"></span>
          }
          @case ('delete') { <span class="iconify text-5xl drop-shadow-sm"
            data-icon="solar:trash-bin-minimalistic-bold-duotone"></span> }
          @case ('logout') { <span class="iconify text-5xl drop-shadow-sm"
            data-icon="solar:logout-3-bold-duotone"></span> }
          @case ('alert') { <span class="iconify text-5xl drop-shadow-sm" data-icon="solar:danger-bold-duotone"></span>
          }
          }
        </div>
      </div>

      <!-- Content Typography -->
      <h3 class="text-lg font-black text-gray-900 dark:text-white mb-2 leading-tight tracking-tight uppercase">
        {{ title }}
      </h3>
      <p class="text-[12px] text-gray-500 leading-relaxed">
        {{ message }}
      </p>
    </div>

    <!-- Action Section (Small Premium Buttons) -->
    <div class="pt-5 flex justify-center gap-2.5">
      <button (click)="onCancel()"
        class="py-2 px-4 rounded-xl text-xs font-semibold text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 transition-all flex items-center justify-center gap-1.5 cursor-pointer active:scale-95">
        <span class="iconify text-lg" data-icon="solar:close-circle-bold-duotone"></span>
        {{ cancelLabel }}
      </button>

      <button (click)="onConfirm()" [class]="'py-2 px-4 rounded-xl text-xs font-bold text-white transition-all flex items-center justify-center gap-1.5 cursor-pointer active:scale-95 shadow-lg hover:-translate-y-0.5 ' + 
        (type === 'delete' || type === 'alert' ? 'bg-red-500 hover:bg-red-600 shadow-red-500/30' : 
         'bg-primary hover:opacity-90 shadow-primary/30')">
        <span class="iconify text-lg" [attr.data-icon]="
          type === 'confirmation' ? 'solar:check-circle-bold-duotone' :
          type === 'question' ? 'solar:check-read-bold-duotone' :
          type === 'delete' ? 'solar:trash-bin-minimalistic-bold-duotone' :
          type === 'logout' ? 'solar:logout-3-bold-duotone' :
          'solar:check-circle-bold-duotone'
        "></span>
        {{ confirmLabel }}
      </button>

    </div>
  </div>
</div>